var map = {
	"./cap05-02-option-01_video.mp4": 3810,
	"./cap05-02-option-02_video.mp4": 2650,
	"./cap05-02.mp4": 1006,
	"./cap05-03_video.mp4": 5966,
	"./cap05-03_video_no scelta.mp4": 1359,
	"./cap051-01-option-04-02-01-01.mp4": 7312,
	"./cap051-01-option-04-02-01-02_video01.mp4": 9686,
	"./cap051-01-option-04-02-02-01.mp4": 4387,
	"./cap051-04-01_video01.mp4": 983,
	"./cap051-04-01_video02.mp4": 7963,
	"./cap051-04-01_video03.mp4": 3287,
	"./cap051-04-02_video01.mp4": 7374,
	"./cap051-04-02_video02.mp4": 589,
	"./cap051-04_video01.mp4": 1271,
	"./cap052-01-option-04-02-02-02_video.mp4": 2887,
	"./cap052-04-01_video01.mp4": 1150,
	"./cap052-04-02_video01.mp4": 2244,
	"./cap052-04-02_video02.mp4": 8127,
	"./cap052-04-option-04-02-01-02_video01.mp4": 1510,
	"./cap052-04-option-04-02-02-02_video.mp4": 3373,
	"./chatTemp (copy).mp4": 8321,
	"./chatTemp.mp4": 7915
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5115;